import { Box, Grid } from "@material-ui/core";
import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import CommonBreadcrumb from "src/components/Breadcrumb/CssBreadcrumb";
import CssSelector from "src/components/Selector/CssSelector";
import { HOLDER } from "src/config/constants";
import AnalysisProvider, { useAnalysisContext } from "src/context/analysisContext";
import CreditScoreDistribution from "./CreditScoreDistribution";
import CreditScoreHistogram from "./CreditScoreHistogram";
import CreditScoreHistoryChart from "./CreditScoreHistoryChart";
import TopTable from "./TopTable";
import YourCreditScore from "./YourCreditScore";

const config = {
  [HOLDER.OVERALL]: { label: "Overrall" },
  [HOLDER.ORAI]: { label: "Orai Holder" },
  [HOLDER.DFYN]: { label: "Dfyn Holder" },
};

const CreditScoreLayout = () => {
  const history = useHistory();
  const { holder } = useParams();

  const { fetchStatisticData } = useAnalysisContext().fetch;

  const onHolderChange = (_, selectedItem) => {
    history.push(`/credit-score/${selectedItem.value}`);
  };

  useEffect(() => {
    if (holder) fetchStatisticData(holder);
  }, [holder]);

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
        <CommonBreadcrumb config={[{ text: "scoring" }, { text: "credit score", link: `/credit-score/${holder}` }]} />
        <CssSelector
          defaultSelectedItem={config[holder]}
          config={[
            { label: "overrall", value: HOLDER.OVERALL },
            { label: "Orai Holder", value: HOLDER.ORAI },
            { label: "Dfyn Holder", value: HOLDER.DFYN },
          ]}
          event={{ onChooseItem: onHolderChange }}
        />
      </Box>
      <Grid container spacing={3}>
        <Grid item md={6} xs={12}>
          <YourCreditScore />
        </Grid>
        <Grid item md={6} xs={12}>
          <CreditScoreDistribution />
        </Grid>
        <Grid item md={6} xs={12}>
          <CreditScoreHistoryChart />
        </Grid>
        <Grid item md={6} xs={12}>
          <CreditScoreHistogram />
        </Grid>
        <Grid item xs={12}>
          <TopTable />
        </Grid>
      </Grid>
    </>
  );
};

export default function CreditScore() {
  return (
    <AnalysisProvider>
      <CreditScoreLayout />
    </AnalysisProvider>
  );
}
